import { CountUp } from "./motion";

// KPI tile (preview/components-stat-cards.html): icon disc · value · label · optional delta.
export function Kpi({ emoji, tone, value, label, delta, suffix }: { emoji: string; tone: string; value: number; label: string; delta?: number | null; suffix?: string }) {
  return (
    <div className="kpi">
      <span className={`kpi-ic ${tone}`}>{emoji}</span>
      <div style={{ minWidth: 0 }}>
        <div className="kpi-val"><CountUp value={value} />{suffix}{delta != null && delta !== 0 && <span className={`kpi-delta ${delta > 0 ? "up" : "down"}`}>{delta > 0 ? "▲" : "▼"} {Math.abs(delta)}%</span>}</div>
        <div className="kpi-lbl">{label}</div>
      </div>
    </div>
  );
}
